<div class="product" [class.checked]="check==value && product.available">
    <!-- <div class="info" (click)="product.showcomp=!product.showcomp" *ngIf="product.comp">
        <img src="assets/images/info.png" alt="info">
    </div> -->
    <!-- <div class="flip-container" [class.flipped]="product.showcomp">
        <div class="flipper">
            <div easyzoom *ngIf="loadAvatar" class="main-img"
                [ngClass]="{easyzoom:!product.showcomp,'easyzoom--overlay':!product.showcomp}">
                <img [src]="product.avatar|absolutePath:'products'"
                    [attr.data-zoom-image]="product.avatar|absolutePath:'products'"
                    [alt]="'Livraison '+product.familyName+' '+product.name"
                    [title]="'Livraison '+product.familyName+' '+product.name" />
            </div>
            <div class="main-img" *ngIf="!loadAvatar">
                <div class="loading"></div>
                <img appLazyLoad (lodedImage)="loadAvatar=true" [src]="product.avatar|absolutePath:'products'"
                    [alt]="'Livraison '+product.familyName+' '+product.name"
                    [title]="'Livraison '+product.familyName+' '+product.name" />
            </div>
            <div class="compositions back" *ngIf="product.showcomp">
                <div>
                    <ul>
                        <li *ngFor="let comp of product.comp|toArray">
                            {{comp}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div> -->

    <div class="radio">
        <input type="radio" [id]="name" [attr.disabled]="!product.available ? '' : null" [(ngModel)]="check"
            [name]="name" [value]='value' (change)="change()">
        <label [for]="name" class="radio-label">

            <div easyzoom *ngIf="loadAvatar" class="main-img">
                <img [src]="product.avatar|absolutePath:'products'"
                    [attr.data-zoom-image]="product.avatar|absolutePath:'products'"
                    [alt]="'Livraison '+product.familyName+' '+product.name"
                    [title]="'Livraison '+product.familyName+' '+product.name" />
            </div>
            <div class="main-img" *ngIf="!loadAvatar">
                <div class="loading" *ngIf="loadAvatar"></div>
                <img appLazyLoad (lodedImage)="loadAvatar=true" [src]="product.avatar|absolutePath:'products'"
                    [alt]="'Livraison '+product.familyName+' '+product.name"
                    [title]="'Livraison '+product.familyName+' '+product.name" />
            </div>

            <div class="product-body">
                <h2>{{product.name}}</h2>
            </div>
            <div class="product-footer">
                <!-- <div class="size vcenter">
                        <p>{{product.size}}</p>
                        <div class="price text-right">
                            {{product.price}} €
                        </div>
                    </div> -->
                <div class="action vcenter" *ngIf="product.available">
                    <button *ngIf="product.compositions.length>0 || product.maxNbrIngOptions>0 || product.hasSupp"
                        (click)="personalize()" class="btn personalize" [disabled]="siteClose">
                        Personnaliser
                    </button>
                </div>
                <div class="action vcenter" *ngIf="!product.available">
                        <button  class="btn indisponible" disabled="true">
                            indisponible
                        </button>
                    </div>
                <!-- <div class="action curs vcenter" *ngIf="!product.available">
                    <button class="btn indisponible">indisponible</button>
                </div> -->
            </div>
        </label>
    </div>







    <!-- <div class="indispo" *ngIf="!product.available">
        <p>indisponible</p>
    </div> -->
</div>